import React, { useEffect, useState } from 'react';
import { RootState } from '../../../reducers';
import { bindActionCreators, Dispatch } from 'redux';
import * as actions from '../../../actions';
import * as _actionsSearch from '../../../actions/search';
import * as _actionsProduct from '../../../actions/product';
import { setDigiflexData } from '../../../actions/product';
import * as _actionsFilters from '../../../actions/filters';
import * as _actionsJourney2 from '../../../actions/journey2';
import * as _actionsBasket from '../../../actions/basket';
import { withRouter } from '../../../utils/withRouter';
import { connect, useSelector } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import classNames from 'classnames';
import Spinner from '../../Spinner';
import { Button, EButtonType, KitIcons } from '@repo/apg-ui';
import { getParameterByName } from '../../../utils/toSearchParams';
import { ReactComponent as RedxIcon } from '../../../assets/icons/redX.svg';
import { ReactComponent as InfoIcon } from '../../../assets/icons/new/info-dark.svg';
import './Fastbook.scss';
import IndustriesSelect from '../../IndustriesSelect';
import DigiflexConfiguration from '../Digiflex/DigiflexConfiguration';
import { createDateRange, parseToApiDate } from '../../../utils/react';
import { parseISO } from 'date-fns';
import { prepareAddToBasketPayload } from '../../../utils/payloads';
import { createBasket, removeFromBasket } from '../../../utils/basket';
import ErrorContainer from '../../ErrorContainer/ErrorContainer';
import { useNavigate } from 'react-router';
import AnalogConfiguration from '../Analog/AnalogConfiguration';
import { PartiallyIntegratedUserDataEC } from '../../../reducers/app';
import { SchemaProduct } from '@repo/legacy-commerce-api';

interface Props {
  location: any;
  userDataEC: PartiallyIntegratedUserDataEC;
  intl: any;
  actionsProduct: typeof _actionsProduct;
  actionsFilters: typeof _actionsFilters;
  productsJ2ByUrn: Record<string, SchemaProduct>;
  possibleBookingDates: any;
  actionsJourney2: typeof _actionsJourney2;
  actionsBasket: typeof _actionsBasket;
  productNew: any;
  basketInfo: any;
  digiflex: any;
  industriesByKey: any;
  errors: any;
  notices: any;
}

const Index = ({
  location,
  actionsProduct,
  userDataEC,
  actionsFilters,
  intl,
  actionsJourney2,
  productNew,
  productsJ2ByUrn,
  possibleBookingDates,
  actionsBasket,
  basketInfo,
  industriesByKey,
  errors,
  notices,
}: Props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isDigital, setIsDigital] = useState(false);
  const [invalidDaysInRange, setInvalidDaysInRange] = useState<number[]>([]);
  const [dateRange, setDateRange] = useState([
    createDateRange(new Date(userDataEC.startDate) || new Date(), userDataEC.duration || 7, {
      toEndOfYear: false,
      fullWeeks: true,
    }),
  ]);

  const [duration, setDuration] = useState(userDataEC.duration || 7);
  const [isIndustryEdit, setIsIndustryEdit] = useState(false);
  const [isIndustryAllowed, setIsIndustryAllowed] = useState(true);
  const [isInBasket, setIsInBasket] = useState(false);

  const { digiflex, ui, basketProducts } = userDataEC;

  const defaultProduct: any = {
    name: '',
    mediacount: 2,
    productphotopath: '',
    formatcode: '',
    producttype: '',
    additionalinfo: { restriction: { codes: [] } },
    producturn: '',
    address: '',
    availabilities: [],
    performancevalue: 0,
    priceinformation: {},
    area: [],
    format: '',
  };

  const [product, setProduct] = useState(defaultProduct);

  const _missingParameter = getParameterByName('missingparameter', location.search);

  const navigate = useNavigate();

  const containers = useSelector((state: RootState) => state.app.containers);

  useEffect(() => {
    const _urn = getParameterByName('urn', location.search);
    if (_urn) {
      let extraParam = null;
      if (userDataEC.basketInfo) {
        extraParam = {
          basket: userDataEC.basketInfo?.basket,
          basketreference: userDataEC.basketInfo?.basketreference,
        };
      }
      actionsFilters.fetchIndustries({ context: 'alcohol', ...extraParam });
      actionsFilters.fetchIndustries({ context: 'big5', ...extraParam });

      let startRangeDate;
      if (!_missingParameter && possibleBookingDates) {
        if (possibleBookingDates && possibleBookingDates['start']) {
          startRangeDate = parseISO(possibleBookingDates['start'].date);
        }
      } else {
        if (userDataEC.startDate) {
          startRangeDate = new Date(userDataEC.startDate);
        } else {
          startRangeDate = new Date();
        }
      }

      let initialDuration = userDataEC.duration || 7;
      actionsProduct
        .fetchProductByUrn({ urn: encodeURI(_urn), date: parseToApiDate(startRangeDate) })
        .then((res) => {
          const isProductInBasket =
            Object.keys(basketProducts.productsByUrn).includes(res.data.producturn) && basketProducts.products;
          if (isProductInBasket) {
            setIsInBasket(true);
            startRangeDate = parseISO(basketProducts.productsByUrn[res.data.producturn].startdate);
            setProduct(basketProducts.productsByUrn[res.data.producturn]);
            // @ts-expect-error Open API spec mismatch: duration does not exist on type:
            initialDuration = basketProducts.productsByUrn[res.data.producturn].duration;
            // actionsFilters.updateIndustry(basketProducts.productsByUrn[res.data.producturn].industry);
          } else {
            res.data.startdate = startRangeDate;
            setIsInBasket(false);
            setProduct(res.data);
            const minDays = res.data?.mindays;
            const maxDays = res.data?.maxdays;
            initialDuration = minDays && initialDuration < minDays ? minDays : initialDuration;
            initialDuration = maxDays && initialDuration > maxDays ? maxDays : initialDuration;
          }

          setDuration(initialDuration);

          setIsDigital(res.data.producttype === 'digital');
          if (res.data.producttype === 'digital') {
            actionsProduct.setDigiflexData({
              product: isProductInBasket ? basketProducts.productsByUrn[res.data.producturn] : res.data,
              startDate: startRangeDate,
            });
          }
          const range = createDateRange(startRangeDate, initialDuration, {
            toEndOfYear: false,
            fullWeeks: res.data.producttype !== 'digital',
          });
          setDateRange([range]);
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
        });

      if (!userDataEC.industry) {
        setIsIndustryEdit(true);
      }
      if (userDataEC.industry) {
        setIsIndustryAllowed(!product.additionalinfo?.restriction?.codes?.includes(userDataEC.industry));
      } else {
        setIsIndustryAllowed(true);
      }
    }
  }, [location]);

  const getProductImage = () => {
    if (product) {
      return (product as any).productphotopath + '&resolution=thumbnail';
    } else {
      return '';
    }
  };

  const handleDateChange = (range, newDuration) => {
    setDuration(newDuration);
    const dateRange = range instanceof Date ? createDateRange(range, newDuration) : range;
    setDateRange([dateRange]);
    if (dateRange && dateRange.startDate) {
      actionsFilters.updateStartDate([dateRange.startDate, newDuration]);
      actionsFilters.updateDuration(newDuration);
    }
  };

  const addToBasket = (basketData) => {
    const { basket, basketreference } = basketData;
    let payload;
    if (isDigital) {
      payload = prepareAddToBasketPayload(
        basket,
        basketreference,
        parseToApiDate(dateRange[0].startDate),
        digiflex.duration,
        product.producturn,
        userDataEC.industry,
        digiflex.timeslot,
        digiflex.spotLength,
        digiflex.shareOfTime,
        digiflex.budget,
      );
    } else {
      payload = prepareAddToBasketPayload(
        basket,
        basketreference,
        parseToApiDate(dateRange[0].startDate),
        duration,
        product.producturn,
        userDataEC.industry,
      );
    }

    return actionsBasket
      .addToBasket(payload)
      .then((res) => {
        if (res) {
          actionsBasket
            .getBasketContent(basketData)
            .then((res) => {
              setIsLoading(false);
              closeModal();
            })
            .catch((err) => {
              console.error(err);
              setIsLoading(false);
            });
        } else {
          setIsLoading(false);
        }
      })
      .catch((res) => {
        setIsLoading(false);
      });
  };

  const addOrCreateBasket = () => {
    setIsLoading(true);
    if (userDataEC.basketInfo) {
      if (isInBasket) {
        return removeFromBasket(
          // @ts-expect-error Open API spec mismatch: basketentryid does not exist on type (basketentryId does, capital I):
          userDataEC.basketProducts.productsByUrn[product.producturn].basketentryid,
          userDataEC,
          actionsBasket,
          product.producturn,
        ).then(() => {
          return addToBasket(userDataEC.basketInfo);
        });
      } else {
        return addToBasket(userDataEC.basketInfo);
      }
    } else {
      return createBasket(userDataEC, dateRange[0].startDate, actionsBasket).then((res) => {
        return addToBasket({
          basket: res.data.basket,
          basketreference: res.data.basketreference,
        });
      });
    }
  };

  const closeModal = () => {
    if (isDigital) {
      setDigiflexData({
        product: null,
        timeslot: null,
        timeslotInfo: null,
        initData: undefined,
        isLoading: false,
      });
    }
    setProduct(defaultProduct);
    setIsInBasket(false);
    setIsIndustryEdit(true);
    navigate({ search: '' });
    if (_missingParameter) {
      window.location.reload(); // Seite neu laden, wenn _missingParameter gesetzt ist
    }
  };

  const productInfoBlock = product ? (
    <div className={classNames('p-4 d-flex w-100 productInfo flex-nowrap font-14')}>
      {product.productphotopath && <img className='productImage' alt='Product' src={getProductImage()} />}

      <div className={'ms-48 d-flex flex-column'}>
        {
          <React.Fragment>
            {((product.area && product.area.length > 0) || isDigital) && (
              <div className='font-weight-bold white-space-nowrap'>
                <FormattedMessage id='ec.modals.fastbook.anzFlashen' defaultMessage='Anz. Flächen' />
              </div>
            )}
            {product.mediacount > 1 && <div>{`${product.mediacount} `}</div>}
          </React.Fragment>
        }
        <div className='productInfo-icon'>{KitIcons.getProductIcon(product)}</div>
      </div>
      <div
        className={classNames({
          'ps-48': !ui.isMobile,
          'ms-0 ps-24': ui.isMobile,
        })}
      >
        <div>
          <b>ID:</b>
          <br />
          {product.producturn.split(':')[2]}
        </div>
        <div className={'mt-4'}>
          <b>
            <FormattedMessage id='ec.modals.fastbook.format' defaultMessage='Format:' />
          </b>
          <br />
          {product.format}
        </div>
      </div>
      <div
        className={classNames({
          'ps-48': !ui.isMobile,
          'ms-0 ps-3': ui.isMobile,
        })}
      >
        <div className={'mx-3 font-weight-bold'}>
          <FormattedMessage id='ec.components.productsTable.adresse' defaultMessage='Adresse' />
        </div>
        <div className='mx-3 white-space-wrap'>{product.address}</div>
      </div>
    </div>
  ) : (
    <></>
  );

  return (
    <div
      className={classNames('fastbookModal', {
        modalLoading: isLoading,
      })}
      id='root'
    >
      {isLoading && <Spinner />}
      <div className={classNames('modalHeader d-flex justify-content-between align-items-start h-auto')}>
        <div>
          <div className='font-24 font-bold'>
            <FormattedMessage id='ec.modals.fastbook.title' defaultMessage='Fast booking' />
          </div>
        </div>
        <div className='close-modal align-self-start'>
          <Button onClick={closeModal} className='mt-0'>
            <RedxIcon />
          </Button>
        </div>
      </div>
      <div className={classNames('modalBody h-100')}>
        {isInBasket && (
          <div className='font-14 p-3 font-bold mb-24 rounded bg-grey-light d-flex align-items-center'>
            <InfoIcon
              style={{
                width: '14px',
                marginLeft: '5px',
                marginTop: '-2px',
              }}
              className='notice'
            />
            <div className={'ms-3'}>
              <FormattedMessage
                id='ec.modals.fastbook.productInBasket'
                defaultMessage='Produkt ist bereits im Warenkorb'
              />
            </div>
          </div>
        )}

        {!ui.isMobile && productInfoBlock}
        <div className='font-20 font-bold mt-24'>
          <FormattedMessage id='ec.modals.fastbook.industry.header' defaultMessage='Werbeinhalt und Branche' />
        </div>
        <div className='font-16'>
          <FormattedMessage
            id='ec.modals.fastbook.industry.description'
            defaultMessage='Meine Werbebotschaft enthält einen der folgenden Inhalte:'
          />
        </div>
        <div className='pt-48 pb-48'>
          {userDataEC.industry && (
            <div className={'d-flex py-24 px-4 mb-48 align-items-center justify-content-between bg-light'}>
              <div
                className={classNames('font-16 font-bold text-body flex-wrap', {
                  'font-16': !ui.isMobile,
                  'font-14': ui.isMobile,
                })}
              >
                <FormattedMessage
                  id='ec.modals.fastbook.industry.currentIndustry'
                  defaultMessage='Ihre derzeitige Branche'
                />
                : <span className='ps-3'>{industriesByKey[userDataEC.industry]?.value}</span>
              </div>
              {!isIndustryAllowed && (
                <div className='font-12 text-red px-2 py-2 svg-16 border-red flex-grow-1 flex-shrink-1 line-height-13'>
                  <span className='pe-4'>
                    <FormattedMessage
                      id='ec.modals.fastbook.industry.notAllowed'
                      defaultMessage='Nicht erlaubt für ausgewählte Fläche'
                    />
                  </span>
                  <InfoIcon />
                </div>
              )}
              <div>
                <Button
                  buttonType={EButtonType.BasicLink}
                  className='mt-0'
                  onClick={() => {
                    setIsIndustryEdit(!isIndustryEdit);
                  }}
                >
                  {isIndustryEdit ? (
                    <FormattedMessage id='ec.components.buttons.hide' defaultMessage='Verbergen' />
                  ) : (
                    <FormattedMessage id='ec.components.buttons.change' defaultMessage='Ändern' />
                  )}
                </Button>
              </div>
            </div>
          )}
          {isIndustryEdit && (
            <IndustriesSelect
              isShowIcons={false}
              notAllowed={product.additionalinfo?.restriction?.codes || []}
              notAllowedElement={
                <div className='font-12 text-red px-2 py-2 d-flex align-items-center justify-content-center border-red flex-grow-1 flex-shrink-1 line-height-13'>
                  {ui.isMobile ? (
                    <FormattedMessage id='ec.modals.fastbook.industry.notAllowedShort' defaultMessage='Nicht erlaubt' />
                  ) : (
                    <FormattedMessage
                      id='ec.modals.fastbook.industry.notAllowed'
                      defaultMessage='Nicht erlaubt für ausgewählte Fläche'
                    />
                  )}
                </div>
              }
            />
          )}
        </div>
        <div
          className={classNames({
            'pb-48': ui.isMobile,
            'pb-4': !ui.isMobile,
          })}
        >
          <div className='font-20 font-weight-bold mb-4'>
            <FormattedMessage id='ec.modals.select_date' defaultMessage='Datum wählen' />
          </div>
          {isDigital && digiflex.product ? (
            <DigiflexConfiguration
              intl={intl}
              location={location}
              productsJ2ByUrn={productsJ2ByUrn}
              possibleBookingDates={possibleBookingDates}
              userDataEC={userDataEC}
              actionsJourney2={actionsJourney2}
              actionsBasket={actionsBasket}
              defaultProduct={product}
              industry={userDataEC.industry}
              basketInfo={basketInfo}
              setDigiflexData={actionsProduct.setDigiflexData}
              handleDateChangeParent={handleDateChange}
            />
          ) : (
            <AnalogConfiguration
              intl={intl}
              possibleBookingDates={possibleBookingDates}
              userDataEC={userDataEC}
              actionsJourney2={actionsJourney2}
              handleDateChange={handleDateChange}
              product={product}
              dateRange={dateRange}
              duration={duration}
              setIsLoading={setIsLoading}
              showPriceBlock={true}
              invalidDaysInRange={invalidDaysInRange}
              setInvalidDaysInRange={(flag) => {
                setInvalidDaysInRange(flag);
              }}
            />
          )}
        </div>
        {(errors || notices) && (
          <ErrorContainer
            getDataFromRedux={true}
            journeyType={'journey02'}
            classNameErrorWrapper={'mw-100 m-0 mt-3'}
            classNameErrorContainer={'m-0'}
          />
        )}
      </div>
      <div className={classNames('modalFooter border-top d-flex w-100 h-auto bg-white flex-column')}>
        {ui.isMobile && productInfoBlock}
        <div
          className={classNames('d-flex align-items-center', {
            'justify-content-end': !ui.isMobile,
            'justify-content-between': ui.isMobile,
          })}
        >
          <Button buttonType={EButtonType.BasicLink} className='mt-0 ' onClick={closeModal}>
            <FormattedMessage id='ec.components.buttons.cancel' defaultMessage='Abbrechen' />
          </Button>
          <Button
            buttonType={EButtonType.InvertedPillMedium}
            className='mt-0 ms-24 text-uppercase'
            isDisabled={
              isLoading ||
              !isIndustryAllowed ||
              (isDigital && digiflex.invalidDaysInRange.length === digiflex.duration) ||
              (!isDigital && invalidDaysInRange.length > 0) ||
              !userDataEC.industry ||
              errors.length > 0 ||
              notices.length > 0
            }
            onClick={() => {
              addOrCreateBasket();
            }}
          >
            {isInBasket ? (
              <FormattedMessage id='ec.components.buttons.updateInBasket' defaultMessage='Update' />
            ) : (
              <FormattedMessage id='ec.components.buttons.addToBasket' defaultMessage='Zum Warenkorb hinzufügen' />
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state: RootState, ownProps: any) {
  return {
    ...ownProps,
    ...state.app,
    ...state.router,
    location: state.router.location,
  };
}

function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
  return {
    actionsSearch: bindActionCreators(_actionsSearch as any, dispatch),
    actionsJourney2: bindActionCreators(_actionsJourney2 as any, dispatch),
    actionsProduct: bindActionCreators(_actionsProduct as any, dispatch),
    actionsFilters: bindActionCreators(_actionsFilters as any, dispatch),
    actionsBasket: bindActionCreators(_actionsBasket as any, dispatch),
    dispatch: dispatch,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(Index)));
